import { Link, router } from "@inertiajs/react"
import Layout from "../components/Layout"
import Embed from "../components/Embed"
import LikeButton from "../components/LikeButton"
import PlatformLinks from "../components/PlatformLinks"
import Avatar from "../components/Avatar"

export default function Post({ post }) {
  const date = new Date(post.created_at)
  const formatted = date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
  const isOwner = post.owned_by_current_user

  function handleDelete() {
    if (confirm("Delete this post?")) {
      router.delete(`/posts/${post.id}`)
    }
  }

  return (
    <Layout>
      <div className="py-4">
        <Link href="/" className="text-sm text-stone-500 hover:text-stone-300 transition-colors">
          ← back
        </Link>
      </div>

      {post.body && (
        <div>
          {post.author && (
            <div className="mb-4 flex items-center gap-2 text-sm text-stone-400">
              <Avatar user={post.author} size="sm" />
              <span className="font-medium text-stone-300">@{post.author.username}</span>
            </div>
          )}
          <p className="text-stone-200 leading-relaxed whitespace-pre-wrap text-lg">{post.body}</p>
        </div>
      )}

      {!post.body && post.author && (
        <div className="mb-4 flex items-center gap-2 text-sm text-stone-400">
          <Avatar user={post.author} size="sm" />
          <span className="font-medium text-stone-300">@{post.author.username}</span>
        </div>
      )}

      <Embed url={post.url} embed_type={post.embed_type} />
      <PlatformLinks post={post} />

      <div className="mt-4 flex items-center justify-between">
        <time className="text-xs text-stone-600">{formatted}</time>
        <div className="flex items-center gap-2">
          <LikeButton post={post} />
          {isOwner && (
            <button
              onClick={handleDelete}
              className="text-xs text-stone-700 hover:text-red-500 transition-colors"
            >
              delete
            </button>
          )}
        </div>
      </div>
    </Layout>
  )
}
